import { render, staticRenderFns } from "./TopbarComponent.vue?vue&type=template&id=52b7d080&scoped=true"
import script from "./TopbarComponent.vue?vue&type=script&lang=js"
export * from "./TopbarComponent.vue?vue&type=script&lang=js"
import style0 from "./TopbarComponent.vue?vue&type=style&index=0&id=52b7d080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b7d080",
  null
  
)

export default component.exports